const BOUNDARY_LENGTH = 16

export let boundary = Array.from(crypto.getRandomValues(new Uint8Array(BOUNDARY_LENGTH)))
  .map((byte) => String.fromCharCode(byte))
  .join('')
  .replace(/[^\w\d]/g, '')
